import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "non-production-banner"
}
const _hoisted_3 = {
  key: 2,
  style: {"width":"100%","height":"100vh"}
}
const _hoisted_4 = {
  class: "secondary-font",
  style: {"font-size":"14px","font-weight":"600"}
}
const _hoisted_5 = {
  key: 0,
  class: "secondary-font",
  style: {"font-size":"14px","font-weight":"600"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingCarWheelSpinner = _resolveComponent("LoadingCarWheelSpinner")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_FloatingUnpaidBalance = _resolveComponent("FloatingUnpaidBalance")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isProductionSite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " ⚠️ THIS IS A NON-PRODUCTION SITE USED FOR STAGING/DEVELOPMENT PURPOSES ONLY ⚠️ "))
        : _createCommentVNode("", true),
      (!_ctx.appDataStore.isLoading || _ctx.router.currentRoute.value.name === _ctx.RouteName.LOGIN)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.appDataStore.isLoading && _ctx.userDataStore.getAuthToken !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_LoadingCarWheelSpinner)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.notification.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notification.show) = $event)),
        color: _ctx.notification.color,
        timeout: _ctx.notification.timeout
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.notification.show = false))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.notification.message), 1),
          (_ctx.notification.caption)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.notification.caption), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "color", "timeout"])
    ]),
    (!_ctx.appDataStore.isLoading || _ctx.router.currentRoute.value.name === _ctx.RouteName.LOGIN)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.appDataStore.isLoading)
      ? (_openBlock(), _createBlock(_component_FloatingUnpaidBalance, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}